export default __webpack_public_path__ + "static/media/jp.fe958929.svg";